<template>
  <div class="create-user-wrapper">
    <v-list
      class="pt-0"
      two-line
    >
      <div class="fixed-header ml-2 mt-3 ">
        <v-row class="px-5 ">
          <v-col
            cols="10"
          >
            <h2 v-if="userAction === 'create' || userAction === 'duplicate'">
              Add User
            </h2>
            <h2 v-if="userAction === 'edit'">
              Edit User
            </h2>
          </v-col>
          <v-col
            cols="2"
            class="d-flex justify-end pr-0"
          >
            <v-btn
              class="text-right"
              icon
              @click.stop="closeDrawer()"
              id="close-create-user-drawer-btn"
              v-track="'close-create-user-drawer-btn'"
            >
              <v-icon
                medium
              >
                mdi-close
              </v-icon>
            </v-btn>
          </v-col>
        </v-row>
        <v-row class="px-5">
          <v-col
            class="mb-2 pt-0"
            cols="11"
          >          
            <v-btn
              :loading="loading"              
              @click.stop="saveUserInfo()"
              id="save-create-user-drawer-btn"
              v-track="'save-create-user-drawer-btn'"
              :dark="enableSaveAddUser || userAction !== 'create'"
              :disabled="!enableSaveAddUser && userAction === 'create'"
            >
              SAVE
            </v-btn>
          </v-col>
        </v-row>
      </div>
      <div class="ml-2">
        <v-row class="px-5">
          <v-col cols="12">
            <v-form
              v-model="validAddUserEmail"
              ref="validAddUserEmail"
              lazy-validation
            >
              <v-text-field
                id="add-new-user-email"
                ref="addNewUserEmail"
                v-model.trim="addNewUserEmail"
                label="Email *"
                outlined
                required
                persistent-hint
                :rules="emailRules"
                :disabled="disableUserEmail"
                @input="enableSaveAddUser = true"
                validate-on-blur
              />
            </v-form>
          </v-col>
        </v-row>
        <v-row class="px-5">
          <v-col
            cols="12"
            class="mt-0 pt-0"
          >
            SELECT USER PRIVILEGES
          </v-col>
        </v-row>
        <v-row
          v-if="userAction === 'edit'"
          :class="`px-5 ${$vuetify.breakpoint.smAndUp?'mb-n4':'mb-2'}`"
        >
          <v-col
            cols="10"
            class="my-0 py-0"
          >
            <span>
              Set this contact as primary contact
            </span>
            <span>
              <v-tooltip
                bottom
                color="rgba(0, 0, 0, 0.9)"
                max-width="400px"
              >
                <template v-slot:activator="{ on }">
                  <v-icon v-on="on">
                    mdi-information-outline
                  </v-icon>
                </template>
                <span class="caption">Make this user the point of contact for communications from Maropost. There can only be one primary contact per account.</span>
              </v-tooltip>
            </span>
          </v-col>
          <v-col
            cols="2"
            class="my-0 py-0 d-flex justify-end"
          >
            <v-switch
              id="primary-contact"
              v-track="'primary-contact'"
              v-model="primaryContact"
              color="#03b6fc"
              class="set-primary-contact my-0 py-0"
              @change="checkHasPrimaryContact()"
            />
          </v-col>
        </v-row>
        <v-divider class="mx-5" />
        <v-row class="px-5 mb-n4">
          <v-col cols="10">
            Campaigns
          </v-col>
          <v-col
            class="d-flex justify-end"
            cols="2"
          >
            <v-switch
              id="show-campaigns"
              v-track="'show-campaigns'"
              v-model="roles.campaigns"
              color="#03b6fc"
              class="set-primary-contact my-0 py-0"              
            />
          </v-col>
        </v-row>
        <v-row class="px-5 mb-n4">
          <v-col
            cols="12"
            class="py-0 my-0"
          >
            <span>
              <v-radio-group
                v-model="campaignsRadio"
                class="py-0 my-0"
              >
                <v-radio
                  key="campaign_full_access"
                  value="campaign_full_access"
                  class="pa-0 ma-0"
                  color="#03b6fc"
                  id="campaign-full-access-radio"
                  v-track="'campaign-full-access-radio'"
                  :disabled="!roles.campaigns"
                >
                  <template v-slot:label>
                    <span class="grey-text-color">Campaigns Full Access</span>
                  </template>
                </v-radio>
              </v-radio-group>
            </span>
          </v-col>
        </v-row>
        <v-row class="px-5 mb-n4">
          <v-col
            cols="12"
            class="py-0 my-0"
          >
            <span>
              <v-radio-group
                v-model="campaignsRadio"
                class="py-0 my-0"
              >
                <v-radio
                  key="campaign_edit_schedule"
                  value="campaign_edit_schedule"
                  class="pa-0 ma-0"
                  color="#03b6fc"
                  id="campaign-edit-schedule-radio"
                  v-track="'campaign-edit-schedule-radio'"
                  :disabled="!roles.campaigns"
                >
                  <template v-slot:label>
                    <span class="grey-text-color">Schedule and Send Only</span>
                  </template>
                </v-radio>
              </v-radio-group>
            </span>
          </v-col>
        </v-row>
        <v-row class="px-5 mb-n4">
          <v-col
            cols="12"
            class="py-0 my-0"
          >
            <span>
              <v-radio-group
                v-model="campaignsRadio"
                class="py-0 my-0"
              >
                <v-radio
                  key="campaign_requires_approval"
                  value="campaign_requires_approval"
                  class="pa-0 ma-0"
                  color="#03b6fc"
                  id="campaign-requires-approval-radio"
                  v-track="'campaign-requires-approval-radio'"
                  :disabled="!roles.campaigns"
                >
                  <template v-slot:label>
                    <span class="grey-text-color">Requires Approval to Access</span>
                  </template>
                </v-radio>
              </v-radio-group>
            </span>
          </v-col>
        </v-row>
        <v-divider class="mx-5" />
        <v-row class="px-5 mb-n4">
          <v-col cols="10">
            Accounts and Users
          </v-col>
          <v-col
            class="d-flex justify-end"
            cols="2"
          >
            <v-switch
              id="show-account"
              v-track="'show-account'"
              v-model="roles.account"
              color="#03b6fc"
              class="set-primary-contact my-0 py-0"
            />
          </v-col>
        </v-row>
        <v-row class="px-5 mb-n4">
          <v-col
            cols="12"
            class="py-0 my-0"
          >
            <span>
              <v-radio-group
                v-model="accountRadio"
                class="py-0 my-0"
              >
                <v-radio
                  key="account"
                  value="account"
                  class="pa-0 ma-0"
                  color="#03b6fc"
                  id="account-full-access-radio"
                  v-track="'account-full-access-radio'"
                  :disabled="!roles.account"
                >
                  <template v-slot:label>
                    <span class="grey-text-color">Accounts and Users Full Access</span>
                  </template>
                </v-radio>
              </v-radio-group>
            </span>
          </v-col>
        </v-row>
        <v-row class="px-5 mb-n4">
          <v-col
            cols="12"
            class="py-0 my-0"
          >
            <span>
              <v-radio-group
                v-model="accountRadio"
                class="py-0 my-0"
              >
                <v-radio
                  key="accounts_read_only"
                  value="accounts_read_only"
                  class="pa-0 ma-0"
                  color="#03b6fc"
                  id="account-read-only-radio"
                  v-track="'account-read-only-radio'"
                  :disabled="!roles.account"
                >
                  <template v-slot:label>
                    <span class="grey-text-color">View and Read Only</span>
                  </template>
                </v-radio>
              </v-radio-group>
            </span>
          </v-col>
        </v-row>
        <v-divider class="mx-5" />
        <v-row class="px-5 mb-n4">
          <v-col cols="10">
            Content
          </v-col>
          <v-col
            class="d-flex justify-end"
            cols="2"
          >
            <v-switch
              id="show-contents"
              v-track="'show-contents'"
              v-model="roles.contents"
              color="#03b6fc"
              class="set-primary-contact my-0 py-0"
            />
          </v-col>
        </v-row>
        <v-row class="px-5 mb-n4">
          <v-col
            cols="12"
            class="py-0 my-0"
          >
            <span>
              <v-radio-group
                v-model="contentRadio"
                class="py-0 my-0"
              >
                <v-radio
                  key="no"
                  value="no"
                  class="pa-0 ma-0"
                  color="#03b6fc"
                  id="content-normal-user-radio"
                  v-track="'content-normal-user-radio'"
                  :disabled="!roles.contents"
                >
                  <template v-slot:label>
                    <span class="grey-text-color">Drag And Drop - Normal User</span>
                  </template>
                </v-radio>
              </v-radio-group>
            </span>
          </v-col>
        </v-row>
        <v-row class="px-5 mb-n4">
          <v-col
            cols="12"
            class="py-0 my-0"
          >
            <span>
              <v-radio-group
                v-model="contentRadio"
                class="py-0 my-0"
              >
                <v-radio
                  key="yes"
                  value="yes"
                  class="pa-0 ma-0"
                  color="#03b6fc"
                  id="content-admin-user-radio"
                  v-track="'content-admin-user-radio'"
                  :disabled="!roles.contents"
                >
                  <template v-slot:label>
                    <span class="grey-text-color">Drag And Drop - Admin User</span>
                  </template>
                </v-radio>
              </v-radio-group>
            </span>
          </v-col>
        </v-row>
        <v-divider class="mx-5" />
        <v-row class="px-5 mb-n4">
          <v-col
            cols="10"
            class="mb-0 pb-0"
          >
            <span>
              DNS Setup
            </span>
          </v-col>
          <v-col
            cols="2"
            class="mb-0 pb-0 d-flex justify-end"
          >
            <v-switch
              id="show-sending-domains"
              v-track="'show-sending-domains'"
              v-model="roles.dns_setup"
              color="#03b6fc"
              class="set-primary-contact my-0 py-0"
            />
          </v-col>
        </v-row>
        <v-divider class="mx-5" />
        <v-row class="px-5 mb-n4">
          <v-col
            cols="10"
            class="mb-0 pb-0"
          >
            <span>
              Contact
            </span>
          </v-col>
          <v-col
            cols="2"
            class="mb-0 pb-0 d-flex justify-end"
          >
            <v-switch
              id="show-contacts"
              v-track="'show-contacts'"
              v-model="roles.contacts"
              color="#03b6fc"
              class="set-primary-contact my-0 py-0"
            />
          </v-col>
        </v-row>
        <v-divider class="mx-5" />
        <v-row class="px-5 mb-n4">
          <v-col
            cols="10"
            class="mb-0 pb-0"
          >
            <span>
              Download Contacts
            </span>
          </v-col>
          <v-col
            cols="2"
            class="mb-0 pb-0 d-flex justify-end"
          >
            <v-switch
              id="show-download-contacts"
              v-track="'show-download-contacts'"
              v-model="roles.download_contacts"
              color="#03b6fc"
              class="set-primary-contact my-0 py-0"
            />
          </v-col>
        </v-row>
        <v-divider class="mx-5" />
        <v-row class="px-5 mb-n4">
          <v-col
            cols="10"
            class="mb-0 pb-0"
          >
            <span>
              Survey
            </span>
          </v-col>
          <v-col
            cols="2"
            class="mb-0 pb-0 d-flex justify-end"
          >
            <v-switch
              id="show-surveys"
              v-track="'show-surveys'"
              v-model="roles.surveys"
              color="#03b6fc"
              class="set-primary-contact my-0 py-0"
            />
          </v-col>
        </v-row>
        <v-divider class="mx-5" />
        <v-row class="px-5 mb-n4">
          <v-col
            cols="10"
            class="mb-0 pb-0"
          >
            <span>
              Create Reports
            </span>
          </v-col>
          <v-col
            cols="2"
            class="mb-0 pb-0 d-flex justify-end"
          >
            <v-switch
              id="show-reports"
              v-track="'show-reports'"
              v-model="roles.reports"
              color="#03b6fc"
              class="set-primary-contact my-0 py-0"
            />
          </v-col>
        </v-row>
        <v-divider class="mx-5" />
        <v-row class="px-5 mb-n4">
          <v-col
            cols="10"
            class="mb-0 pb-0"
          >
            <span>
              Download Reports
            </span>
          </v-col>
          <v-col
            cols="2"
            class="mb-0 pb-0 d-flex justify-end"
          >
            <v-switch
              id="show-download-reports"
              v-track="'show-download-reports'"
              v-model="roles.download_reports"
              color="#03b6fc"
              class="set-primary-contact my-0 py-0"
            />
          </v-col>
        </v-row>
        <v-divider class="mx-5" />
        <v-row class="px-5 mb-n4">
          <v-col
            cols="10"
            class="mb-0 pb-0"
          >
            <span>
              Automation
            </span>
          </v-col>
          <v-col
            cols="2"
            class="mb-0 pb-0 d-flex justify-end"
          >
            <v-switch
              id="show-automation"
              v-track="'show-automation'"
              v-model="roles.automation"
              color="#03b6fc"
              class="set-primary-contact my-0 py-0"
            />
          </v-col>
        </v-row>
        <v-divider class="mx-5" />
        <v-row class="px-5 mb-n4">
          <v-col
            cols="10"
            class="mb-0 pb-0"
          >
            <span>
              Forms
            </span>
          </v-col>
          <v-col
            cols="2"
            class="mb-0 pb-0 d-flex justify-end"
          >
            <v-switch
              id="show-forms"
              v-track="'show-forms'"
              v-model="roles.forms"
              color="#03b6fc"
              class="set-primary-contact my-0 py-0"
            />
          </v-col>
        </v-row>
        <v-divider class="mx-5" />
        <v-row class="px-5 mb-n4">
          <v-col
            cols="10"
            class="mb-0 pb-0"
          >
            <span>
              Relational Tables
            </span>
          </v-col>
          <v-col
            cols="2"
            class="mb-0 pb-0 d-flex justify-end"
          >
            <v-switch
              id="show-relational-tables"
              v-track="'show-relational-tables'"
              v-model="roles.relational_tables"
              color="#03b6fc"
              class="set-primary-contact my-0 py-0"
            />
          </v-col>
        </v-row>
        <v-divider class="mx-5" />
        <v-row class="px-5 mb-n4">
          <v-col
            cols="10"
            class="mb-0 pb-0"
          >
            <span>
              FTP
            </span>
          </v-col>
          <v-col
            cols="2"
            class="mb-0 pb-0 d-flex justify-end"
          >
            <v-switch
              id="show-ftp"
              v-track="'show-ftp'"
              v-model="roles.ftp"
              color="#03b6fc"
              class="set-primary-contact my-0 py-0"
            />
          </v-col>
        </v-row>
        <v-divider class="mx-5" />
        <v-row class="px-5 mb-n4">
          <v-col
            cols="10"
            class="mb-0 pb-0"
          >
            <span>
              Mobile
            </span>
          </v-col>
          <v-col
            cols="2"
            class="mb-0 pb-0 d-flex justify-end"
          >
            <v-switch
              id="show-mobile"
              v-track="'show-mobile'"
              v-model="roles.mobile"
              color="#03b6fc"
              class="set-primary-contact my-0 py-0"
            />
          </v-col>
        </v-row>
        <v-divider class="mx-5" />
        <v-row class="px-5 mb-n4">
          <v-col
            cols="10"
            class="mb-0 pb-0"
          >
            <span>
              Push Notification
            </span>
          </v-col>
          <v-col
            cols="2"
            class="mb-0 pb-0 d-flex justify-end"
          >
            <v-switch
              id="show-push-notifications"
              v-track="'show-push-notifications'"
              v-model="roles.push_notifications"
              color="#03b6fc"
              class="set-primary-contact my-0 py-0"
            />
          </v-col>
        </v-row>
        <v-divider class="mx-5" />
        <v-row class="px-5 mb-n4">
          <v-col
            cols="10"
            class="mb-0 pb-0"
          >
            <span>
              Coupon Codes
            </span>
          </v-col>
          <v-col
            cols="2"
            class="mb-0 pb-0 d-flex justify-end"
          >
            <v-switch
              id="show-coupon-codes"
              v-track="'show-coupon-codes'"
              v-model="roles.coupon_codes"
              color="#03b6fc"
              class="set-primary-contact my-0 py-0"
            />
          </v-col>
        </v-row>
        <v-divider class="mx-5" />
        <v-row class="px-5">
          <v-col cols="10">
            <span>
              <a href="https://www.maropost.com/privacy-policy/"
               id="add-user-privacy-policy" v-track="'privacy-policy-link'"><b>Privacy Policy</b></a>
            </span>
          </v-col>
        </v-row>
      </div>
    </v-list>
    <v-dialog
      v-model="confirmSetPrimaryContactModal"
      max-width="700"
      @click:outside="confirmSetPrimaryContactModal = false; primaryContact = !primaryContact"
    >
      <v-card class="px-5">
        <v-card-title class="headline">
          Confirm Request
        </v-card-title>
        <v-card-text class="mt-1 mb-n4" style="font-size:16px">
          A primary contact already exists for this account. Do you wish to make this person the new primary contact?
        </v-card-text>
        <v-card-actions class="mb-1">
          <v-spacer />
          <v-btn
            text
            @click="confirmSetPrimaryContactModal = false; primaryContact = !primaryContact"
            id="primary-contact-modal-cancel-btn"
            v-track="'primary-contact-modal-cancel-btn'"
          >
            CANCEL
          </v-btn>
          <v-btn
            text
            :loading="loading"
            @click.stop="setPrimaryContact()"
            id="primary-contact-modal-confirm-btn"
            v-track="'primary-contact-modal-confirm-btn'"
          >
            CONFIRM
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
  import { $invitations } from '@/services'
  export default {
    name: 'CreateUserDrawer',
    data () {
      return {
        accountId: '',
        loading: false,
        enableSaveAddUser: false,
        hasPrimaryContact: false,
        confirmSetPrimaryContactModal: false,
        invitationId: '',
        userAction: '',
        addNewUserEmail: '',
        disableUserEmail: false,
        validAddUserEmail: true,
        campaignsRadio: '',
        contentRadio: '',
        accountRadio: '',
        isPrimaryContact: false,
        roles: {
          campaigns: false,
          account: false,
          dns_setup: false,
          contacts: false,
          download_contacts: false,
          contents: false,
          surveys: false,
          reports: false,
          download_reports: false,
          automation: false,
          forms: false,
          relational_tables: false,
          ftp: false,
          mobile: false,
          push_notifications: false,
          coupon_codes: false,
          campaign_full_access: false,
          campaign_edit_schedule: false,
          campaign_requires_approval: false,
          bee_admin: false,
          accounts_read_only: false,
        },
        primaryContact: false,
        emailRules: [
          v => !!v || 'Email is required',
          v => !v || !!v.trim() || 'Email cannot be blank',
          v => /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(v) || 'Invalid email.'],
      }
    },
    watch: {
      'roles.account': function () {
        if(!this.roles.account){
          this.accountRadio = ''
        }
        else if(this.roles.account && !this.accountRadio){
          this.accountRadio = 'account'
        }
      },
      'roles.contents': function () {
        if(!this.roles.contents){
          this.contentRadio = ''
        }
        else if(this.roles.contents && !this.contentRadio){
          this.contentRadio = 'no'
        }
      },
      'roles.campaigns': function () {
        if(!this.roles.campaigns){
          this.campaignsRadio = ''
        }
        else if(this.roles.campaigns && !this.campaignsRadio){
          this.campaignsRadio = 'campaign_full_access'
        }
      },
    },
    mounted () {
      if (this.$store.state.auth.editAccountId) {
        this.accountId = this.$store.state.auth.editAccountId
      } else {
        this.accountId = this.$store.state.auth.account.id
      }
      let drawerResponse = this.$store.state.ui.drawer.right.response;
      this.hasPrimaryContact = drawerResponse.hasPrimaryContact
      this.invitationId = drawerResponse.invitationId
      this.userAction = drawerResponse.userAction
      this.isPrimaryContact = drawerResponse.isPrimary
      if (this.userAction === 'create') {
        let item = ''
        for (item in this.roles) {
          this.roles[item] = true
        }
        this.roles.campaign_full_access = true
        this.roles.campaign_edit_schedule = false
        this.roles.campaign_requires_approval = false
        this.campaignsRadio = 'campaign_full_access'
        this.roles.bee_admin = false
        this.contentRadio = 'no'
        this.roles.account = true
        this.roles.accounts_read_only = false
        this.accountRadio = 'account'
      } else if (this.userAction === 'edit' || this.userAction === 'duplicate') {
        this.loading = true
        $invitations.show(this.invitationId).then(response => {
          if (this.userAction === 'edit') {
            this.addNewUserEmail = response.data.data.invitation.email
            this.disableUserEmail = true
          }          
          const responseRoles = response.data.data.invitation.roles
          this.primaryContact = response.data.data.invitation.primary_contact
          let i = 0
          let element = ''
          for (i = 0; i < responseRoles.length; i++) {
            element = responseRoles[i]
            this.roles[element] = true
          }
          if (this.roles.campaign_full_access) {
            this.campaignsRadio = 'campaign_full_access'
          } else if (this.roles.campaign_edit_schedule) {
            this.campaignsRadio = 'campaign_edit_schedule'
          } else if(this.roles.campaign_requires_approval){
            this.campaignsRadio = 'campaign_requires_approval'
          }
          if (this.roles.contents && this.roles.bee_admin) {
            this.contentRadio = 'yes'
          } else if(this.roles.contents && !this.roles.bee_admin){
            this.contentRadio = 'no'
          }
          if(this.roles.accounts_read_only){
            this.accountRadio = 'accounts_read_only'
            this.roles.account = true
          }
          else if(this.roles.account){
            this.accountRadio = 'account'
          }
        }).catch(error => {
          console.log('error', error)
        }).finally(() => {
          this.loading = false
        })
      }
    },
    methods: {
      closeDrawer () {
        this.$store.commit('ui/drawer.right', {
          show: false,
          component: null,
          response: { checkUserUpdateInfo: true },
        })
      },
      checkHasPrimaryContact(){
        if(this.hasPrimaryContact === false && this.primaryContact){
          this.setPrimaryContact()
        } else if(this.isPrimaryContact === true && this.primaryContact === false) {
          this.setPrimaryContact()
        } else {
          this.confirmSetPrimaryContactModal = true
        }
      },
      setPrimaryContact(){
        this.loading = true
        const payload = {
          invitation: {
            email: this.addNewUserEmail,
            primary_contact: this.primaryContact
          },        
        }
        $invitations.update(this.invitationId, payload).then(response => {
          this.$store.commit('ui/snackbar', { message: response.data.data.invitation.primary_contact ? 
          "Successfully assigned primary user" : "Successfully unassigned primary user",
          type: 'success' })
          this.closeDrawer()
        }).finally(() => {
          this.loading = false
        })
      },
      saveUserInfo () {
        if (!this.$refs.validAddUserEmail.validate()) return
        this.loading = true
        let payload = {
          invitation: {
            email: this.addNewUserEmail,
            roles: []
          },          
        }
        let item = ''
        let i = 0
        for (item in this.roles) {
          if(item === 'campaign_full_access' ||
          item === 'campaign_edit_schedule' ||
          item === 'campaign_requires_approval'){
            if(i === 0 && this.campaignsRadio){
              payload.invitation.roles.push(this.campaignsRadio)
            }         
            i++
          }
          else if(item === 'bee_admin'){
            if(this.contentRadio === 'yes'){
              payload.invitation.roles.push(item)
            }            
          }
          else if(item === 'accounts_read_only'){            
            if(this.roles.account && this.accountRadio === 'accounts_read_only'){
              payload.invitation.roles.push(item)
            }           
          }
          else{
            if(this.roles[item] === true){
              payload.invitation.roles.push(item)          
            }
          }
        }
        if (this.userAction === 'create' || this.userAction === 'duplicate') {
          $invitations.create(payload).then(response => {
            this.$store.commit('ui/snackbar', { message: this.$options.filters.firstCharCapital(response.data.message),
            type: 'success' })
            this.closeDrawer()
          }).finally(() => {
            this.loading = false
          })
        } else {
          payload.invitation.primary_contact = this.primaryContact
          $invitations.update(this.invitationId, payload).then(response => {
            this.$store.commit('ui/snackbar', { message: "User updated successfully",
            type: 'success' })
            this.closeDrawer()
          }).finally(() => {
            this.loading = false
          })
        }
      },
    },
  }
</script>
<style lang="scss">
.create-user-wrapper{
  .grey-text-color{
    color: rgba(0,0,0,0.54);
  }
}
</style>
